import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as socketService from '../services/socket';

/**
 * Shown on the Home and Join pages when this tab still has a game session. This is the recovery
 * path for players who accidentally left the room (back button, mis-click): one click puts them
 * back in their seat. The server keeps that seat for the whole game.
 */
const ResumeSessionCard: React.FC = () => {
  const navigate = useNavigate();
  const [session, setSession] = useState(() => socketService.getSessionInfo());

  if (!session.roomId || !session.username) {
    return null;
  }

  const { roomId, username } = session;

  const handleRejoin = () => {
    navigate(`/room/${roomId}`, { state: { username } });
  };

  const handleForget = () => {
    socketService.clearSessionInfo();
    setSession({ roomId: null, username: null });
  };

  return (
    <div className="resume-card" role="status">
      <span className="resume-card-icon" aria-hidden="true">↺</span>
      <div className="resume-card-body">
        <strong>Back to your game?</strong>
        <p>
          You were in room <code className="code-inline">{roomId}</code> as <strong>{username}</strong>.
        </p>
      </div>
      <div className="resume-card-actions">
        <button type="button" className="btn btn-primary btn-sm" onClick={handleRejoin}>
          Rejoin
        </button>
        <button type="button" className="btn btn-ghost btn-sm" onClick={handleForget}>
          Forget
        </button>
      </div>
    </div>
  );
};

export default ResumeSessionCard;
